
type Props = {
  fileUrl?: string;
};

const FileViewer = (props: Props) => {
  const { fileUrl } = props;
  if (!fileUrl) {
    return null;
  }

  return (
    <div className="relative group">
      <img
        src={fileUrl}
        className="h-[100px] w-auto object-scale-down object-center border border-black/10 rounded-md overflow-hidden group-hover:opacity-0"
      />
      <span className="absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 bg-black/20 p-1 rounded-md hidden group-hover:block">
        <img
          src={fileUrl}
          className="h-[30vh] w-auto object-scale-down object-center border border-black/10 rounded-md overflow-hidden"
        />
      </span>
    </div>
  );
};

export default FileViewer;
